import { TFunction } from 'i18next';
import * as yup from 'yup';
import { getPasswordValidationSchema } from 'domains/auth/util';

type ResetPasswordForm = {
  code: string;
  password: string;
  passwordConfirm: string;
};

export const getLocalizedSchema = (t: TFunction): yup.ObjectSchema<ResetPasswordForm> =>
  yup
    .object({
      code: yup.string().required(t('form.validation.fieldIsRequired')),
      password: getPasswordValidationSchema(t),
      passwordConfirm: yup
        .string()
        .oneOf([yup.ref('password')], t('form.validation.passwordMustMatch'))
        .required(t('form.validation.fieldIsRequired')),
    })
    .required();

export type FormData = yup.InferType<ReturnType<typeof getLocalizedSchema>>;
